import { Signal } from '@angular/core';

export abstract class UnitEntryStrategy {
  abstract quantityEntryDisabled: Signal<boolean>;
  abstract enabled: Signal<boolean>;
}
